module.exports = __webpack_public_path__ + "static/media/main idea.b4275839.mp3";